import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
   
    pageTitleContainer:{
        display:'flex',
        justifyContent:'space-between',
        padding:'4px 10px',
        marginBottom:'16px',
        textTransform:'capitalize'
    },
    pageInfoTitleContainer:{
        position:'relative',
        display:'flex',
        textAlign:'center',
        alignItems: 'center',
        justifyContent:'space-between',
        padding:'9px 10px'
    },
     pageInfoButtonTitleContainer:{
        position:'relative',
        display:'flex',
        textAlign:'center',
        alignItems: 'center',
        justifyContent:'space-around',
        padding:'4px 0px'
    },
     iconBtnSmall: {
        height: '16px !important',
        width: '16px !important',
        backgroundColor: '#009688 !important',
        color: '#fff !important',
        padding: '10px 16px !important',
        borderRadius: '5px !important',
        fontSize: '12px !important',
        margin: '0 4px !important',
        '&:hover': {
            backgroundColor: '#00796b !important', // Darker shade on hover
        },
        '& .MuiSvgIcon-root': {
            fontSize: '12px !important', // Adjust icon size
        }
    },
  
}));

export default useStyles;
